exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tchek-gallery__container{display:grid;grid-template-columns:repeat(auto-fill, minmax(150px, 1fr));gap:10px\n}\n.tchek-gallery__img{width:100%;height:auto;-o-object-fit:cover;object-fit:cover;border-radius:4px\n}\n.tchek-gallery__item{margin:0rem\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ca1facde","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/valuation-tool/components/Sections/TchekSummaryGallery.vue
// module id = zAHs
// module chunks = 1 2 4 5 15 17 18 19